import React from 'react';
import { breakpoint, theme } from '../../../theme';
import styled from 'styled-components';
import { ActionIconField } from './ActionIconField';
import { SvgComponent } from '../../../assets';

export type ActionTimeInput = Date | number | string;

const ActionTimeSectionContent = styled.div`
  display: flex;
  flex-direction: column;

  > * + * {
    margin-top: ${theme.spacings[1].rem};

    ${breakpoint('sm')`
      margin-top: ${theme.spacings[2].rem};
    `}
  }
`;

export type ActionTimeSectionProps = {
  time: ActionTimeInput;
  durationText?: string | JSX.Element;
  actionItemTimeField: {
    icon: SvgComponent;
    content: JSX.Element | string;
    formatter: (value: ActionTimeInput) => string;
  };
  durationIcon: SvgComponent;
};

export const ActionTimeSection: React.FC<ActionTimeSectionProps> = ({
  time,
  actionItemTimeField,
  durationText,
  durationIcon,
}) => {
  return (
    <ActionTimeSectionContent>
      {actionItemTimeField && (
        <ActionIconField icon={actionItemTimeField.icon}>
          {actionItemTimeField.content}{' '}
          <strong>{actionItemTimeField.formatter(time)}</strong>
        </ActionIconField>
      )}
      {durationText && (
        <ActionIconField icon={durationIcon}>{durationText}</ActionIconField>
      )}
    </ActionTimeSectionContent>
  );
};
